// src/pages/PrivacyPolicy.jsx
import React from "react";

export default function PrivacyPolicy() {
  const lastUpdated = "January 2026";

  return (
    <main style={styles.main}>
      <article style={styles.article}>
        <div style={styles.header}>
          <h1 style={styles.h1}>Privacy Policy – Jampot Rally App</h1>
          <p style={styles.updated}>
            <strong>Last updated:</strong> {lastUpdated}
          </p>
        </div>

        <section style={styles.section}>
          <p>
            The Jampot Rally App is provided to support attendees of the Jampot
            Rally organised by the AJS &amp; Matchless Owners Club.
          </p>
          <p>
            We take your privacy seriously and aim to keep the app simple and
            transparent.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Information We Collect</h2>
          <p>The Jampot Rally App does <strong>not</strong> collect, store, or share personal information.</p>
          <ul style={styles.ul}>
            <li>No user accounts are required</li>
            <li>No names, email addresses, phone numbers, or payment details are collected</li>
            <li>No advertising or tracking technologies are used</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Push Notifications</h2>
          <p>
            The app may use push notifications to provide important rally
            information, such as schedule updates or announcements.
          </p>
          <ul style={styles.ul}>
            <li>Push notifications do not use personal data</li>
            <li>You can disable notifications at any time in your device settings</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Analytics</h2>
          <p>The app does not use third-party analytics or tracking tools.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Third Parties</h2>
          <p>
            The Jampot Rally App does not share data with third parties.
          </p>
          <p>
            Links within the app (for example, to external websites) are provided
            for convenience. We are not responsible for the privacy practices of
            those external sites.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Changes to This Policy</h2>
          <p>
            If the app’s functionality changes in a way that affects privacy,
            this policy will be updated accordingly.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Contact</h2>
          <p>If you have any questions about this privacy policy, please contact:</p>
          <p style={styles.contact}>
            <strong>AJS &amp; Matchless Owners Club</strong>
            <br />
            Email:{" "}
            <a href="mailto:southwest@jampot.com" style={styles.link}>
              southwest@jampot.com
            </a>
          </p>
         
        </section>
      </article>
    </main>
  );
}

const styles = {
  main: {
    padding: "150px 16px",
    display: "flex",
    justifyContent: "center",
  },
  article: {
    width: "100%",
    maxWidth: 860,
    lineHeight: 1.6,
    fontSize: 16,
  },
  header: {
    marginBottom: 24,
  },
  h1: {
    fontSize: 32,
    margin: "0 0 8px 0",
  },
  updated: {
    margin: 0,
    opacity: 0.85,
  },
  section: {
    marginTop: 22,
  },
  h2: {
    fontSize: 20,
    margin: "0 0 8px 0",
  },
  ul: {
    marginTop: 8,
    paddingLeft: 22,
  },
  contact: {
    marginTop: 10,
  },
  link: {
    textDecoration: "underline",
  },
  note: {
    marginTop: 8,
    fontSize: 14,
    opacity: 0.8,
  },
};